/**
 * Vehicle utility functions
 * Helper functions for working with vehicle data
 */

import { Vehicle } from "../api/vehiclesApi";
import { Coordinate } from "../types/distance";

/**
 * Vehicle location with vehicle ID for tracking
 */
export interface VehicleLocation extends Coordinate {
  vehicleId: number;
}

/**
 * Checks if a vehicle has valid location coordinates
 * @param vehicle - Vehicle to check
 * @returns True if vehicle has both latitude and longitude
 */
export const hasVehicleLocation = (vehicle: Vehicle | undefined): boolean => {
  return !!(vehicle?.lastLatitude && vehicle?.lastLongitude);
};

/**
 * Extracts location from vehicle with vehicle ID
 * @param vehicle - Vehicle to extract location from
 * @returns VehicleLocation object or null if location not available
 */
export const getVehicleLocation = (
  vehicle: Vehicle
): VehicleLocation | null => {
  if (!hasVehicleLocation(vehicle)) return null;
  return {
    vehicleId: vehicle.id,
    latitude: vehicle.lastLatitude ?? 0,
    longitude: vehicle.lastLongitude ?? 0,
  };
};
